import { IConfigName } from './interface/field-type-object';

interface IItemObj {
  id: string;
  value: string;
  label?: string;
}

interface IDefaultDataObject {
  configName: IConfigName;
  required: boolean;
  type: string;
}

const defaultData: IDefaultDataObject = {
  configName: IConfigName.Checklist,
  required: false,
  type: 'enum',
};

interface IDefaultConfigObject {
  dataType: string;
  data: IItemObj[];
  multiselect: boolean;
  displayType: string;
}

const defaultConfig: IDefaultConfigObject = {
  data: [],
  multiselect: false,
  displayType: 'checklist',
  dataType: 'static'
};

const value = {
  title: 'Checklist',
  icon: {
    black: require('../../icons/black/circle-check.png'),
    white: require('../../icons/white/circle-check.png'),
    blue: require('../../icons/blue/circle-check.png'),
  },
  style: {
    width: '20px',
    height: '20px'
  },
  defaultData,
  defaultConfig
}

export default value;